import { NgModule } from '@angular/core';

import { AnalyticsEventsDirective } from 'idt-analytics-api/directives/analytics-events.directive';
import { IdtAnalyticsApiModule } from 'idt-analytics-api/idt-analytics-api.module';


@NgModule({
  imports: [
    IdtAnalyticsApiModule
  ],
  exports: [
    AnalyticsEventsDirective,
  ],
  declarations: [
    AnalyticsEventsDirective
  ],
})
export class AnalyticsEventDirectiveModule {}
